import React, { Component } from "react"
import * as dateHelper from "../../helpers/date"
import config from "react-global-configuration"
import CheckoutBasketParking from "../../../styleguide/js/components/checkout-basket-parking"
import * as tracking from "../../helpers/tracking"
class ParkingCheckoutBasket extends Component {
  constructor(props) {
    super(props)
    this.checkoutBasketRef = React.createRef()
    this.state = {
      detailsExpanded: false,
    }
  }

  formatDate(date, time) {
    return dateHelper.formatDate(date, "DD MMM. YYYY") + " " + time
  }

  componentDidMount() {
    new CheckoutBasketParking({ el: this.checkoutBasketRef.current })
  }

  handleUseCoupon(useVoucher) {
    const { arrivalDate, arrivalTime, departureDate, departureTime, affiliateCode } = this.props
    const { couponCode } = this.state

    if (useVoucher) {
      this.props.performParkingSearch(arrivalDate, arrivalTime, departureDate, departureTime, couponCode, affiliateCode, true)
    } else {
      this.props.performParkingSearch(arrivalDate, arrivalTime, departureDate, departureTime, "", affiliateCode, true)
    }
  }

  handleExpandCollapse = () => {
    var eventLabel = this.state.detailsExpanded ? "collaps" : "expand"
    tracking.trackParkingFlowClick("order summary", eventLabel, this.props)
    this.setState({ detailsExpanded: !this.state.detailsExpanded })
  }

  handleChangeParking = () => {
    const bookingResult = this.props.bookingResult
    const { booking } = bookingResult
    tracking.trackParkingFlowClick("order summary", "edit parking", this.props)
    this.props.performParkingSearch(
      booking.arrivalDate,
      booking.arrivalTime,
      booking.departureDate,
      booking.departureTime,
      booking.promotionCode,
      booking.affiliateCode,
      false,
    )
  }

  handleRemoveExtra = (product) => {
    tracking.trackParkingFlowClick("order summary", "remove car care", this.props)
    this.props.removeExtraFromBooking(product, () => setTimeout(() => this.setState({ detailsExpanded: false }), 2000))
  }

  render() {
    const { globals } = this.props
    const textKeys = config.get("textKeys.basket.miniBasket") || {}
    const checkoutSummaryTextKeys = config.get("textKeys.checkout.summary") || {}
    const extraServicesElementTextKeys = config.get("textKeys.extraServices.element") || {}

    let bookingResult = this.props.bookingResult

    if (!this.props.bookingResult) {
      bookingResult = {
        booking: {
          arrivalDate: this.props.arrivalDate,
          arrivalTime: this.props.arrivalTime,
          departureDate: this.props.departureDate,
          departureTime: this.props.departureTime,
          voucher: this.props.voucher,
          price: this.props.price,
          amountPayable: this.props.amountPayable,
        },
        carPark: {
          name: this.props.name,
        },
        product: {
          name: this.props.name,
        },
        activeBookingExtraProducts: {
          product: {
            name: this.props.name,
          },
          variants: {
            productOffer: {
              name: this.props.name,
            },
          },
        },
        modificationSummary: {
          netChargesForAmendment: this.props.netChargesForAmendment,
          originalBookingValue: this.props.originalBookingValue,
          newBookingValue: this.props.newBookingValue,
          amendmentFees: this.props.amendmentFees,
        },
        parking: {
          amount: this.props.amount,
        },
      }
    }

    const { booking, carPark, product, parking, activeBookingExtraProducts, modificationSummary } = bookingResult
    const isUpgrade = !!modificationSummary
    const amountToPay = !isUpgrade
      ? booking.amountPayable
      : modificationSummary.netChargesForAmendment !== 0
        ? booking.amountPayable
        : modificationSummary.originalBookingValue +
          modificationSummary.netChargesForAmendment -
          (modificationSummary.newBookingValue + modificationSummary.amendmentFees)

    const thirdPartyPromoLabel = booking?.thirdPartyPromoLabelText

    return (
      <div
        className={`checkout-basket checkout-basket--parking js--checkout-basket-parking${this.state.detailsExpanded ? " is-open" : ""}`}
        ref={this.checkoutBasketRef}
      >
        <div className="checkout-basket__top">
          <div className="details">
            <div className="details__item details__item--time">
              <span className="label">{textKeys.time}</span>
              <p>
                <span className="text">{this.formatDate(booking.arrivalDate, booking.arrivalTime)}</span>
                <span className="icon--small">
                  <svg className="svg-icon">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowright-white">
                      &nbsp;
                    </use>
                  </svg>
                </span>
                <span className="text">{this.formatDate(booking.departureDate, booking.departureTime)}</span>
                <button
                  className="details__item-edit button--text-link button js--open-modal"
                  data-template="parkingTimePickerModalTemplate"
                  onClick={() => this.props.parkingTimeModalToogle()}
                >
                  <span>{checkoutSummaryTextKeys.edit || "Rediger"}</span>
                </button>
              </p>
            </div>

            <div className="details__extras details-wrapper">
              <div className="details__item details__item--extra">
                <span className="label">{textKeys.product}</span>
                <div className="details__item-content">
                  <p>
                    <span className="text">{`${product.name} ${carPark.name}${thirdPartyPromoLabel ? ` - ${thirdPartyPromoLabel}` : ""}`}</span>
                    <button className="button details__item-edit button--text-link" onClick={() => this.handleChangeParking()}>
                      <span>{checkoutSummaryTextKeys.edit || "Rediger"}</span>
                    </button>
                  </p>
                  <p className="details__item-price">
                    <span className="text">{this.props.priceFormatter(booking.promotionCode ? parking.originalAmount : parking.amount)}</span>
                  </p>
                </div>
              </div>

              {activeBookingExtraProducts.length > 0
                ? activeBookingExtraProducts.map((extra, index) => {
                    return (
                      <div className="details__item details__item--extra" key={index}>
                        <span className="label">{extra.product.name}</span>
                        <div className="details__item-content">
                          <p>
                            <span className="text">{extra.variants[0].productOffer.name}</span>
                            <button className="details__item-edit button--text-link button" onClick={() => this.handleRemoveExtra(extra.product)}>
                              <span>{extraServicesElementTextKeys.remove || "Fjern"}</span>
                            </button>
                          </p>
                          <p className="details__item-price">
                            <span className="text">{this.props.priceFormatter(this.props.getExtraPrice(extra.product, booking))}</span>
                          </p>
                        </div>
                      </div>
                    )
                  })
                : ""}

              {booking.promotionCode ? (
                <div className="details__item details__item--extra">
                  <span className="label">{textKeys.promotionCode}</span>
                  <div className="details__item-content">
                    <p>
                      <span className="text">{booking.promotionCode}</span>
                      <button className="details__item-edit button--text-link button" onClick={() => this.handleUseCoupon(false)}>
                        <span>{textKeys.remove}</span>
                      </button>
                    </p>
                    <p className="details__item-price">
                      <span className="text">- {this.props.priceFormatter(booking.promotionSaving)}</span>
                    </p>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="details__item details__item--price">
              <span className="label">{textKeys.total}</span>
              <p>
                <span className="text">{this.props.priceFormatter(amountToPay)}</span>
              </p>
            </div>
          </div>
          <div className="details-toggle">
            <button className="details-toggle__button js--toggle-details" onClick={() => this.handleExpandCollapse()}>
              <span className="icon">
                <svg className="svg-icon svg-icon--edit">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowupangle">
                    &nbsp;
                  </use>
                </svg>
              </span>
            </button>
          </div>
        </div>

        <button className="js--backdrop checkout-basket__backdrop" onClick={() => this.handleExpandCollapse()} />
      </div>
    )
  }
}

export default ParkingCheckoutBasket
